import React, { useMemo } from "react";
import { STATUS_OPTIONS } from "../../utils/constants";
import { translate } from "../../utils/translations/translate";
import { Link } from "react-router-dom";
import Button from "../UI/Button";
import { Popupmenu } from "../UI/PopupMenu";
import { SITE_LINKS_SCHEMA } from "../../router/navlinks";
import { DOWNLOAD_OPTIONS } from "../../utils/constants";
import { Dropdown } from "../UI/Dropdown";
import Input from "../UI/Input";
import { StyledStatusFilter } from "./styles";
const ProjectListFilters = ({
  projectKey,
  setProjectKey,
  statusKey,
  setStatusKey,
  resourceKey,
  setResourceKey,
  onReportsClick,
  currentRecordsLength,
  selectedRecordsLength,
  onDeleteAction
}) => {
  const drpDwnStatusOptions = useMemo(() => {
    return [
      {
        label: "All Status",
        value: "",
      },
      ...STATUS_OPTIONS,
    ];
  }, []);
  const popupOptions = useMemo(() => {
    return [{ label: "Delete Project(s)", key: "delete",isDisabled:!selectedRecordsLength }, ...DOWNLOAD_OPTIONS];
  }, [selectedRecordsLength]);
  return (
    <header className="tma__project-table-filters">
      <div className="tma__project-table-filters--left">
        <Input
          id={"tma_prj_search_box"}
          placeholderLabelText={translate("labels.allProjects")}
          labelText={""}
          value={projectKey}
          onChange={(e) => setProjectKey(e.target.value)}
        />
        <Input
          id={"tma_prj_rsrc_search_box"}
          placeholderLabelText={translate("labels.allResources")}
          labelText={""}
          value={resourceKey}
          onChange={(e) => setResourceKey(e.target.value)}
        />
        <StyledStatusFilter>
          <Dropdown
            placeholder={translate("labels.status")}
            options={drpDwnStatusOptions}
            initialValue={statusKey}
            onChange={({ value }) => {
              setStatusKey(value);
            }}
          />
        </StyledStatusFilter>
      </div>
      <div className="tma__project-table-filters--right">
        <Popupmenu
          variantStyle={"secondary"}
          popupOptions={popupOptions}
          label={translate("labels.moreOptions")}
          disabled={currentRecordsLength === 0}
          onOptionSelect={({ key }) => {
            if(key === "delete"){
              onDeleteAction();
            }
            else{
              onReportsClick(key);
            }
          }}
        />
        <Link
          className="tma__add_project_link"
          to={SITE_LINKS_SCHEMA.PROJECT_CREATION}
        >
          <Button
            className="tma__add_project"
            text={translate("labels.addNewProject")}
          />
        </Link>
      </div>
    </header>
  );
};

export { ProjectListFilters };
